import { t } from '../i18n';
import { isAUS } from './countriesHelpers';

function getUSA() {
  return {
    solid: t('dash.common.select_options.level.solid_label'),
    outstanding: t('dash.common.select_options.level.outstanding_label'),
    epic: t('dash.common.select_options.level.epic_label'),
  };
}

function getAUS() {
  return {
    tier_1: t('dash.common.select_options.level.tier_1_label'),
    tier_2: t('dash.common.select_options.level.tier_2_label'),
    tier_3: t('dash.common.select_options.level.tier_3_label'),
    tier_4: t('dash.common.select_options.level.tier_4_label'),
  };
}

const toLowerCase = (skills: string[]) => skills.map(item => item.toLowerCase());

function getSkillsUSA(lowercase: boolean = false) {
  const USA = getUSA();
  const skills = [USA.solid, USA.outstanding, USA.epic];

  return lowercase ? toLowerCase(skills) : skills;
}

function getSkillsAUS(lowercase: boolean = false) {
  const AUS = getAUS();
  const skills = [AUS.tier_1, AUS.tier_2, AUS.tier_3, AUS.tier_4];

  return lowercase ? toLowerCase(skills) : skills;
}

export const skillsKeysUSA = getSkillsUSA(true);

export const filterSkillsKeysUSA = (levels: string[]) => {
  const lowerCaseLevels = levels.map(item => item.toLowerCase());

  return skillsKeysUSA.filter(item => lowerCaseLevels.includes(item));
};

export const skillsKeysAUS = ['tier_1', 'tier_2', 'tier_3', 'tier_4'];

export const filterSkillsKeysAUS = (levels: string[]) => {
  const lowerCaseLevels = levels.map(item => item.toLowerCase());

  return skillsKeysAUS.filter(item => lowerCaseLevels.includes(item));
};

export function getSkillLabel(index: number) {
  return (isAUS() ? getSkillsAUS() : getSkillsUSA())[index];
}

export const getSkillMapper = () => ({ USA: getUSA(), AUS: getAUS() });
